class Date {
    static path = 'values/date';
    static vueMethods = {
        'triggerDatePicker': ({bucket1, node}) => {
            window.VueApp.$modal.show('litegraph-date-picker');
        },
        'saveDatePicker': ({date, node}) => {
            node.properties.value = date
            window.VueApp.$modal.hide('litegraph-date-picker');
        }
    }

    constructor(mutator){
        this.addOutput("value", "date");
        this.addProperty("value", '');
        // this.widgets_up = true;
        this.bgcolor = '#bfb5b2';
        this.title = 'Static Date';
        this.desc = 'Constant date';

        let datePickerNodeSelf = this;
        this.addWidget("button","Select Date",null,(v) => {
            window.VueApp.$refs.triggerBuilder.runNodeMethod('triggerDatePicker', {
                bucket1: this.properties.value,
                node: datePickerNodeSelf
            }, true);
        } );

    }

    onExecute() {
        this.setOutputData(0, this.properties["value"]);
    }

    getTitle() {
        if (this.flags.collapsed) {
            return this.properties.value;
        }
        return this.title;
    }

    onDrawBackground() {
        //show the current value
        this.outputs[0].label = this.properties["value"];
    }

}

module.exports = Date
